export default __webpack_public_path__ + "static/media/Mapa.26bf636c.png";